import api from "./interceptor";
import axios from "axios";

export const signIn = (formData: { username: string; password: string; rememberMe: boolean }) => {
  let postData = {
    userName: formData.username,
    password: formData.password,
  };

  // return api.post("/login", postData);
  return api.post("/login/send-login-otp", postData);
};

export const verifyLogin = (formData: object) => {
  return api.post("/login/verify-login-otp", formData);
};

export const ownerRegister = (formData: {
  companyName: string;
  businessName: string;
  companyContact: string;
  mobile: string;
  companyLocation: string;
  industryType: number;
  nid: string;
  vat: number;
  representativeName: string;
  email: string;
  username: string;
  password: string;
  profileImage: string;
}) => {
  let postData = {
    companyName: formData.companyName,
    businessName: formData.businessName,
    companyContact: formData.companyContact,
    mobile: formData.mobile,
    companyLocation: formData.companyLocation,
    industryType: formData.industryType,
    accountType: 1,
    NID: formData.nid,
    VAT: formData.vat,
    representativeName: formData.representativeName,
    email: formData.email,
    userName: formData.username,
    password: formData.password,
    image: formData.profileImage,
  };

  return api.post("/registration/owner-registration", postData);
};

export const sentOTP = (formData: any) => {
  let postData = {
    userId: formData.userId,
    mobile: formData.mobile,
  };

  return api.post("/registration/send-the-OTP", postData);
};

export const resendLoginOtp = () => {
  return api.post("/login/re-send-login-otp");
};

export const resendRegisterOtp = () => {
  return api.post("/registration/send-the-OTP");
};

export const verifyTheNumber = (formData: any) => {
  return api.post("/registration/verified-the-number", formData);
};

export const downloadFile = (url: string) => {
  return axios.get(url, {
    responseType: "blob",
  });
};

// endpoint manu list :-

// 01 channel service
// 02 rate card service
// 03 user service
// 04 mask service
// 05 contact list service
// 06 black list service
// 07 campaign list service
// 08 report service
// 09 dashboard service
// 10 configaration service

// -------------------# 01 channel services endpoints start here #-------------------------

export const getChannelList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/channel-management/get-all-channels", formData, { params: params });
};

export const getDataChannelList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/data-channel-management/get-all-data-channels", formData, { params: params });
};

export const createChannel = (formData: object) => {
  return api.post("/channel-management/create-new-channel", formData);
};

export const createDataChannel = (formData: object) => {
  return api.post("/data-channel-management/create-new-data-channel", formData);
};

export const updateChannel = (formData: object) => {
  return api.post("/channel-management/update-channel-details", formData);
};

export const updateDataChannel = (formData: object) => {
  return api.post("/data-channel-management/update-data-channel-details", formData);
};

export const getChannelListWithoutPagination = () => {
  return api.post("/channel-management/get-all-channels-without-pagination");
};

export const getDataChannelListWithoutPagination = () => {
  return api.post("/data-channel-management/get-all-data-channels-without-pagination");
};

// -------------------# 02 rate card services endpoints start here #-------------------------

export const getRateCardList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/rate-card-management/get-all-rate-card-details", formData, { params: params });
};

export const createRateCard = (formData: object) => {
  return api.post("/rate-card-management/create-new-rate-card", formData);
};

export const updateRateCard = (formData: object) => {
  return api.post("/rate-card-management/update-rate-details", formData);
};

export const getRateCardDetilsById = (formData: object) => {
  return api.post("/rate-card-management/get-rate-card-details-by-id", formData);
};

export const getRateCardListWithoutPagination = () => {
  return api.post("/rate-card-management/get-all-rate-card-details-without-pagination");
};

export const getDigitalRateCardList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/data-rate-card-management/get-all-data-rate-card-details", formData, { params: params });
};

export const createDigitalRateCard = (formData: object) => {
  return api.post("/data-rate-card-management/create-new-data-rate-card", formData);
};

export const updateDigitalRateCard = (formData: object) => {
  return api.post("/data-rate-card-management/update-data-rate-details", formData);
};

export const getDigitalRateCardDetilsById = (formData: object) => {
  return api.post("/data-rate-card-management/get-data-rate-card-details-by-id", formData);
};

export const getDigitalRateCardListWithoutPagination = () => {
  return api.post("/data-rate-card-management/get-all-data-rate-card-details-without-pagination");
};

// -------------------# 03 user services endpoints start here #-------------------------

export const updateUserDataConfigurations = (formData: object) => {
  return api.post("/owner-management/update-owner-system-data-operator-configuration-details", formData);
};

export const updateUserSmsConfigurations = (formData: object) => {
  return api.post("/owner-management/update-owner-system-operator-configuration-details", formData);
};

export const createAdminUser = (formData: object) => {
  return api.post("/admin-management/create-new-admin", formData);
};

export const updateAdminUser = (formData: object) => {
  return api.post("/admin-management/update-admin-details", formData);
};

export const changeAdminPassword = (formData: object) => {
  return api.post("/admin-management/update-admin-password", formData);
};

export const getAllAdminUserList = (formData: object, page: number, rowsPerPage: number) => {
  const params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/admin-management/get-all-admin-details", formData, { params: params });
};

export const createOwnerUser = (formData: object) => {
  return api.post("/owner-management/create-new-owner", formData);
};

export const approveOrRejectOwner = (formData: object) => {
  return api.post("/owner-management/approve-or-reject-owner", formData);
};

export const getApprovePendingOwnerList = (formData: object, page: number, rowsPerPage: number) => {
  const params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/owner-management/get-approve-pending-owner-list", formData, { params: params });
};

export const getAllOwnerList = (formData: object, page: number, rowsPerPage: number) => {
  const params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/owner-management/get-all-owners", formData, { params: params });
};

export const getAllOwnerListWithoutPagination = () => {
  return api.post("/owner-management/get-all-owners-without-pagination");
};

export const updateOwnerSystemConfig = (formData: object) => {
  return api.post("/owner-management/update-owner-system-operator-configuration-details", formData);
};

export const updateOwnerSystemConfigPassword = (formData: object) => {
  return api.post("/owner-management/update-owner-system-operator-configuration-passwords", formData);
};

export const updateOwnerUser = (formData: object) => {
  return api.post("/owner-management/update-owner-details", formData);
};

export const getOwnerDetailsById = (formData: object) => {
  return api.post("/owner-management/get-owner-details-by-id", formData);
};

export const changeOwnerPassword = (formData: object) => {
  return api.post("/owner-management/update-owner-password", formData);
};

export const getAllOwnerCompanyListWithoutPagination = () => {
  return api.post("/owner-management/get-company-list-without-pagination");
};

export const createChildUser = (formData: object) => {
  return api.post("/child-user-management/create-new-child-user", formData);
};

export const getAllChildUserList = (formData: object, page: number, rowsPerPage: number) => {
  const params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/child-user-management/get-all-child-users", formData, { params: params });
};

export const updateChildUser = (formData: object) => {
  return api.post("/child-user-management/update-child-user-details", formData);
};

export const changeChildPassword = (formData: object) => {
  return api.post("/child-user-management/update-child-user-password", formData);
};

export const createReportUser = (formData: object) => {
  return api.post("/report-user-management/create-new-report-user", formData);
};

export const getAllReportUser = (formData: object, page: number, rowsPerPage: number) => {
  const params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/report-user-management/get-all-report-user-details", formData, { params: params });
};

export const updateReportUserDetails = (formData: object) => {
  return api.post("/report-user-management/update-report-user-details", formData);
};

export const approveOrRejectChildUser = (formData: object) => {
  return api.post("/child-user-management/approve-child-user", formData);
};

export const updateReportUserPassword = (formData: object) => {
  return api.post("/report-user-management/update-report-user-password", formData);
};

export const getOwnerProfileDetails = () => {
  return api.post("/owner-management/get-profile-details");
};

export const getOwnerRatecardDetails = () => {
  return api.post("/owner-management/get-rate-card-details");
};

export const getApprovePendingChildUserList = (formData: object) => {
  return api.post("/child-user-management/get-approve-pending-child-users-list", formData);
};

export const searchOwnerByCompanyName = (formData: object) => {
  return api.post("/owner-management/get-owner-company-list-from-search", formData);
};

export const getChildListByMaskId = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/child-user-management/get-child-user-list-by-mask-id", formData, { params: params });
};

export const getAllApprovePendingChildList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/child-user-management/get-all-approve-pending-child-users-in-system", formData, { params: params });
};

// -------------------# 04 mask services endpoints start here #-------------------------

export const getOwnerMaskList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/mask-management/get-owner-mask-list", formData, { params: params });
};

export const getAllMaskList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/mask-management/get-all-mask-list", formData, { params: params });
};

export const getMaskListByOwnerId = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/mask-management/get-mask-by-owner-id", formData, { params: params });
};

export const getOwnerMaskListWithoutPagination = () => {
  return api.post("/mask-management/get-owner-mask-list-without-pagination");
};

export const addNewMask = (formData: object) => {
  let postData = formData;

  return api.post("/mask-management/create-new-mask", postData);
};

export const changeMaskStatus = (formData: object) => {
  let postData = formData;

  return api.post("/mask-management/change-mask-status", postData);
};

// -------------------# 05 contact list services endpoints start here #-------------------------

export const getContactList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/contact-list-management/get-all-contact-lists", formData, { params: params });
};

export const getAllNumberForAContactList = (formData: object, page: number, rowsPerPage: number) => {
  let postData = formData;

  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/contact-list-management/get-contact-list-numbers-by-contact-list-id", postData, { params: params });
};

export const createContactList = (formData: FormData) => {
  return api.post("/contact-list-management/create-new-contact-list", formData);
};

export const getContactListDetailsById = (formData: object) => {
  return api.post("/contact-list-management/get-contact-list-details-by-contact-list-id", formData);
};

export const changeContactListName = (formData: object) => {
  return api.post("/contact-list-management/change-contact-list-name", formData);
};

export const addNumbersToContactList = (formData: FormData) => {
  return api.post("/contact-list-management/add-more-numbers-to-contact-list", formData);
};

export const changeContactListStatus = (formData: object) => {
  return api.post("/contact-list-management/change-contact-list-status", formData);
};

export const removeContactListNumbers = (formData: object) => {
  return api.post("/contact-list-management/remove-contact-list-numbers", formData);
};

export const getAllContactList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/contact-list-management/get-all-contact-lists-in-system", formData, { params: params });
};

// -------------------# 06 black list services endpoints start here #-------------------------

export const addNewBlackListNumber = (formData: FormData) => {
  return api.post("/black-list-number-management/add-new-numbers-to-black-list", formData);
};

export const removeBlackListNumbers = (formData: object) => {
  let postData = formData;

  return api.post("/black-list-number-management/remove-black-list-numbers", postData);
};

export const getBlackListNumbers = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/black-list-number-management/get-all-black-list-numbers", formData, { params: params });
};

// -------------------# 07 campaign services endpoints start here #-------------------------

export const getConfigarationData = (formData: object) => {
  return api.post("/campaign-creation-data-management/get-campaign-creation-data", formData);
};

export const createBulkCampaign = (formData: FormData) => {
  return api.post("/campaigns/create-bulk-campaign", formData);
};

export const createPersonalCampaign = (formData: FormData) => {
  return api.post("/campaigns/create-personalized-campaign", formData);
};

export const getCampaignData = (formData: object) => {
  let postData = formData;

  return api.post("/campaign-list-view-management/get-campaign-details-by-campaign-id", postData);
};

export const getNumberList = (formData: object, page: number, rowsPerPage: number) => {
  let postData = formData;
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/campaign-list-view-management/get-campaign-numbers-by-campaign-id", postData, { params: params });
};

export const changeStatus = (formData: object) => {
  let postData = formData;

  return api.post("/campaign-list-view-management/change-campaign-status", postData);
};

export const createAdminBulkCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaigns/admin/create-bulk-campaign", postData);
};

export const createAdminPersonalCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaigns/admin/create-personalized-campaign", postData);
};

export const createDataBulkCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaigns/admin/create-data-bulk-campaign", postData);
};

export const createDataPersonalCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaigns/admin/create-data-personalized-campaign", postData);
};

export const createParentDataBulkCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaigns/parent/create-data-bulk-campaign", postData);
};

export const createParentDataPersonalCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaigns/parent/create-data-personalized-campaign", postData);
};

export const getAllCampaigns = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/campaign-list-view-management/get-all-campaign-list", formData, { params: params });
};

// -------------------# 08 report services endpoints start here #-------------------------

export const getFinanceReportData = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/reports-management/get-financial-report-data", formData, { params: params });
};

export const getFinanceReportDataChannelWise = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("reports-management/get-financial-report-data-channel-wise", formData, { params: params });
};

export const getDataFinanceReportDataChannelWise = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/reports-management/get-data-financial-report", formData, { params: params });
};

export const searchUserByUserName = (formData: object) => {
  return api.post("/campaign-list-view-management/search-users-by-user-name-or-company-name", formData);
};

// -------------------# 09 dashboard services endpoints start here #-------------------------

export const getDashboardData = (formData: object) => {
  let postData = formData;

  return api.post("/dashboard-management/get-dashboard-details", postData);
};

// -------------------# 10 configuration services endpoints start here #-------------------------

export const getTaxDetails = () => {
  return api.post("/tax-management/get-tax-details");
};

export const updateTaxDetails = (formData: object) => {
  let postData = formData;

  return api.post("/tax-management/update-tax-details", postData);
};
